import { CheckCircle, AlertCircle, Loader2, Mail, RefreshCw, ExternalLink } from 'lucide-react'
import { useSignatureInject } from '@/hooks/use-signature-inject'
import { APP_BASE_URL } from '@/lib/constants'

export function ComposeScreen() {
  const { status, retry } = useSignatureInject()

  return (
    <div className="flex flex-col h-full overflow-y-auto">
      <div className="p-4 space-y-3">
        <h2 className="text-sm font-semibold text-secondary-700">Athenty Signature</h2>

        {status === 'idle' && null}

        {status === 'loading' && (
          <div className="flex items-center gap-2 rounded-md border border-secondary-200 bg-secondary-50 px-3 py-2.5 text-sm text-secondary-600">
            <Loader2 className="h-4 w-4 animate-spin shrink-0" />
            Inserting your signature…
          </div>
        )}

        {status === 'injected' && (
          <div className="flex items-center gap-2 rounded-md border border-green-200 bg-green-50 px-3 py-2.5 text-sm text-green-700">
            <CheckCircle className="h-4 w-4 shrink-0" />
            Signature inserted.
          </div>
        )}

        {status === 'already-present' && (
          <div className="flex items-center gap-2 rounded-md border border-secondary-200 bg-secondary-50 px-3 py-2.5 text-sm text-secondary-600">
            <CheckCircle className="h-4 w-4 shrink-0" />
            Signature already present.
          </div>
        )}

        {status === 'no-template' && (
          <div className="space-y-2">
            <div className="flex items-start gap-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2.5 text-sm text-amber-700">
              <Mail className="h-4 w-4 shrink-0 mt-0.5" />
              <span>No signature template is configured for your organization.</span>
            </div>
            <a
              href={`${APP_BASE_URL}/settings/email-templates`}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-1 text-xs text-primary-600 hover:text-primary-700 transition-colors"
            >
              Open Email Templates settings
              <ExternalLink className="h-3 w-3" />
            </a>
          </div>
        )}

        {status === 'error' && (
          <div className="space-y-2">
            <div className="flex items-start gap-2 rounded-md border border-red-200 bg-red-50 px-3 py-2.5 text-sm text-red-700">
              <AlertCircle className="h-4 w-4 shrink-0 mt-0.5" />
              <span>Couldn't load signature. Check your connection and try again.</span>
            </div>
            <button
              onClick={retry}
              className="inline-flex items-center gap-1.5 rounded px-3 py-1.5 text-xs font-medium bg-primary-600 text-white hover:bg-primary-700 transition-colors"
            >
              <RefreshCw className="h-3 w-3" />
              Retry
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
